module.exports = __webpack_public_path__ + "static/img/60.1ada6d22.png";